class GerenciamentoEtiquetasModal {
    static get $inject() {
        return ['$scope', 'gql', '$uibModal', 'Etiquetas']
    }

    constructor($scope, gql, modal, Etiquetas) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
        this.modal = modal
        this.Etiquetas = Etiquetas

        this.perPage = 50
    }

    $onInit() {
        this.promise = this.search()
    }

    adicionarEtiqueta() {
        return this.modal
            .open({
                component: 'cadastroEtiquetaModal',
                size: 'md',
                resolve: {
                    etiqueta: () => ({ nome: this.searchText }),
                    empresaId: () => this.resolve.empresaId
                }
            })
            .result
            .then(etiqueta => {
                if (etiqueta) this.etiquetas.unshift(etiqueta)
            })
    }

    editarEtiqueta(etiqueta) {
        return this.modal
            .open({
                component: 'cadastroEtiquetaModal',
                size: 'md',
                resolve: {
                    etiqueta: () => etiqueta,
                    empresaId: () => this.resolve.empresaId
                }
            })
            .result
            .then(etiqueta => {
                if (etiqueta) {
                    const index = this.etiquetas.findIndex(e => e.id == etiqueta.id)
                    this.etiquetas[index] = etiqueta
                }
            })
    }

    deleteEtiqueta(etiqueta) {
        Confirm.warning("Atenção", "Deseja realmente remover esta etiqueta?", {
            'Não': angular.noop,
            'Sim': () => {
                etiqueta.deletePromise = this.Etiquetas
                    .deleteEtiqueta(this.resolve.empresaId, etiqueta)
                    .then(() => {
                        const index = this.etiquetas.findIndex(e => e.id === etiqueta.id)
                        this.etiquetas.splice(index, 1)

                        this.searchContext = new Date()
                    })
                    .finally(() => this.apply())

                this.apply()
            }
        })
    }

    pageChange(page) {
        return this.search(page)
    }

    search(page = {}) {
        const filter = { search: this.searchText }

        this.promise = this.Etiquetas
            .listEtiquetas(this.resolve.empresaId, { filter, ...page, size: this.perPage })
            .then(({ etiquetas, after, before }) => {
                if (page.after) {
                    this.currentPage = this.currentPage + 1
                }

                if (page.before) {
                    this.currentPage = this.currentPage - 1
                }

                if (!page.before && !page.after) {
                    this.currentPage = 1

                    this.searchContext = new Date()
                }
                this.etiquetas = etiquetas
                this.nextPage = after
                this.previousPage = before

            })
            .catch(console.error)
            .finally(() => this.apply())
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('gerenciamentoEtiquetasModal', {
        controller: GerenciamentoEtiquetasModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Gerenciamento de etiquetas" close="$ctrl.close">
                <modal-body>
                    <div>
                        <highlighted>
                            <main>Gerenciamento de etiquetas</main>
                            <secondary>Você poderá gerenciar suas etiquetas abaixo.</secondary>
                        </highlighted>
                    </div>

                    <div class="search-form">
                        <ef-search-input
                            ng-model="$ctrl.searchText"
                            ng-change="$ctrl.search()" 
                            ng-model-options="{ debounce: 500 }">
                        </ef-search-input>

                        <button class="btn btn-primary" ng-click="$ctrl.adicionarEtiqueta()">
                            Adicionar
                        </button>
                    </div>

                    <div class="etiquetas">
                        <loading promise="$ctrl.promise">
                            <cursor-paginator
                                per-page="$ctrl.perPage" 
                                next-page="$ctrl.nextPage" 
                                previous-page="$ctrl.previousPage"
                                current-page="$ctrl.currentPage" 
                                current-page-size="$ctrl.etiquetas.length" 
                                on-change="$ctrl.pageChange($page)" 
                                search-context="$ctrl.searchContext">
                            </cursor-paginator>
                            <ul>
                                <li ng-hide="$ctrl.etiquetas.length">
                                    <span class="text-muted text-center">
                                        Nenhuma etiqueta cadastrada para esta empresa.
                                    </span>
                                </li>
                                <li ng-repeat="etiqueta in $ctrl.etiquetas">
                                    <ef-etiqueta 
                                        nome="{{etiqueta.nome}}" 
                                        descricao="{{etiqueta.descricao}}" 
                                        cor="{{etiqueta.cor}}">
                                    </ef-etiqueta>
                                        
                                    <span class="etiqueta-descricao">{{etiqueta.descricao}}</span>

                                    <promise-tracker promise="etiqueta.deletePromise" active="isActive"> 
                                        <div ng-hide="isActive" class="edit-tools">
                                            <a href="javascript:void(0)" ng-click="$ctrl.editarEtiqueta(etiqueta)">
                                                <i class="fa fa-pencil"></i>
                                            </a>

                                            <a class="text-danger" href="javascript:void(0)" ng-click="$ctrl.deleteEtiqueta(etiqueta)">
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </div>

                                        <div ng-show="isActive">
                                            <i class="fa fa-spin fa-spinner"></i>
                                            Removendo...
                                        </div>
                                    </promise-tracker>
                                </li> 
                            </ul>
                        </loading>             
                    </div>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" ng-click="$ctrl.close()">
                        Fechar
                    </button>
                </modal-footer>
            </modal>
        `
    })
